import type { CandidateStage } from '@/modules/hiring-manager/hooks/useCandidatePipelineQuery';

// A record, so leaving out a stage is a type error rather than a hidden group.
const stageCopy: Record<CandidateStage, { title: string; hint?: string }> = {
  sourced: {
    title: 'Sourced',
    hint: 'Matches found by sourcing, with no automated next step.',
  },
  shortlisted: {
    title: 'Shortlisted',
    hint: 'Strong matches found by sourcing, not contacted yet.',
  },
  outreach: {
    title: 'Outreach',
    hint: 'Finlay is reaching out and waiting for a reply.',
  },
  prescreening: {
    title: 'Prescreening',
    hint: 'In or finished the AI prescreen.',
  },
  waiting: {
    title: 'Needs your decision',
    hint: 'Introduced to you and waiting on your call.',
  },
  interviewing: { title: 'Interviewing' },
  hired: { title: 'Hired' },
  passed: { title: 'Passed' },
};

export type StageInfo = {
  key: CandidateStage;
} & (typeof stageCopy)[CandidateStage];

/** Every stage in pipeline order, with the customer-facing copy. */
export const stages: StageInfo[] = (
  Object.keys(stageCopy) as CandidateStage[]
).map((key) => ({ key, ...stageCopy[key] }));
